
import { AbstractControl, AsyncValidatorFn, ValidationErrors} from '@angular/forms';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { WidgetbuilderService } from '../widget-builder-service/widgetbuilder.service';
import { WidgetBuilderVarService } from '../widget-builder-service/widget-builder-var.service';
  
export class WidgetnameValidator {
  static createValidator(widgetservice:WidgetbuilderService,widgetbuildervarservice:WidgetBuilderVarService): AsyncValidatorFn {
    return (control: AbstractControl): Observable<ValidationErrors> => {
      if(widgetbuildervarservice.widgetEditMode){
        return of(null);
    } else {
      return widgetservice.checkIfWidgetnameExists(control.value)
      .pipe(
        map((result: any) =>{
          if(result.widgetnameExists){ 
            return {widgetnameAlreadyExists: true }
          }else{
            return null
          } 
        })
      );
    }
    };
  }
}